import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AssetSvgDefs} from 'src/app/common/models/ai-reports/shared/assets';
import {ChatStore} from 'src/app/services/store';
import {ClientAssetService} from 'src/app/services/AIReports';
import {AbstractAssetComponent} from '../abstract-asset.component';
import {environment} from "../../../../../../../../environments/environment";
import {AiChatFacade} from "@components/mainmenu/reports-menu/ai-reports/ai-reports-sub-menu/chat/ai-chat.facade";

@Component({
  selector: 'app-asset-svg-defs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './asset-svg-defs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetSvgDefsComponent extends AbstractAssetComponent<AssetSvgDefs> {

  private readonly chatStore = inject(ChatStore);
  private readonly clientAssetService = inject(ClientAssetService);
  private facade = inject(AiChatFacade);

  // Construct direct image URL; template will use this for <img src> binding.
  // The image is scoped to a thread and retrieved by asset ID via cookie-authenticated endpoint.
  getUrl(): string {
    const a = this.asset();
    return `${environment.apiBaseUrl}/assets/${this.facade.activeThreadId()}/${a.id}/image`;
  }
}
